



















import Vue from 'vue';
import StepContent from '@/components/StepContent.vue';
import BackgroundTools from '@/components/BackgroundTools.vue';
import BodyOrgans from '@/components/BodyOrgans.vue';

export default Vue.extend<any, any, any, any>({
	components: {
		StepContent, BackgroundTools, BodyOrgans,
	},
});
